export default `
  mutation removeEnterpriseMemberByAdmin($email: String!, $payerUserId: String) {
    removeEnterpriseMemberByAdmin(email: $email, payerUserId: $payerUserId) {
      success
      message
    }
  }
`
